module.exports = "/images/compass.svg?60ef1257bbdb007d8adefcba5600dc6e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/images/compass.svg
// module id = 52
// module chunks = 2 4 5